import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';
import { doSignOut } from '../../firebase/auth';
//import Dropdown from 'react-bootstrap/Dropdown';

const Header = () => {
    const navigate = useNavigate();
    const { userLoggedIn } = useAuth();
    const headingRef = useRef(null);
    const buttonContainerRef = useRef(null);
    const [headingColor, setHeadingColor] = useState('inherit');

    useEffect(() => {
        if (headingRef.current) {
            headingRef.current.style.paddingTop = '10px';
        }
        if (buttonContainerRef.current) {
            const buttons = buttonContainerRef.current.querySelectorAll('.nav-button');
            buttons.forEach(button => {
                button.style.paddingTop = '10px';
            });
        }
    },);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <nav className="flex items-center justify-between w-full z-20 fixed top-0 left-0 h-16 bg-transparent px-4">
            <div className="flex justify-center flex-grow">
                <Link
                    to="/"
                    className="text-2xl font-bold"
                    ref={headingRef}
                    onMouseEnter={() => setHeadingColor('red')}
                    onMouseLeave={() => setHeadingColor('inherit')}
                    style={{ color: headingColor }}
                >
                    Fastest Supreme Bot
                </Link>
            </div>
            <div className="flex gap-x-2" ref={buttonContainerRef}>
                {userLoggedIn ? (
                    <div className="flex gap-x-2">
                        <button
                            onClick={() => navigate('/instructions')}
                            className="nav-button"
                        >
                            Instructions
                        </button>
                        <button
                            onClick={() => navigate('/bot')}
                            className="nav-button"
                        >
                            Bot
                        </button>
                        <button className="nav-button" onClick={() => navigate('/minigame')}>
                            Mini Game
                        </button>

                        <div ref={dropdownRef} className="relative">
                            <button onClick={toggleDropdown} className="nav-button">
                                My Profile
                            </button>
                            {dropdownOpen && (
                                <div className="absolute right-0 mt-2 w-48 bg-black rounded-md shadow-lg overflow-hidden z-10">
                                    <button onClick={() => {
                                        navigate('/profile');
                                        setDropdownOpen(false);
                                    }} className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-100">
                                        Manage Account
                                    </button>
                                    <button onClick={() => {
                                        doSignOut().then(() => {
                                            navigate('/login');
                                            setDropdownOpen(false);
                                        });
                                    }} className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-100">
                                        Log Out
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (

                    <div className="flex gap-x-2">
                        <button className="nav-button" onClick={() => navigate('/login')}>
                            Login
                        </button>
                        <button className="nav-button" onClick={() => navigate('/register')}>
                            Register New Account
                        </button>
                        <button className="nav-button" onClick={() => navigate('/minigame')}>
                            Mini Game
                        </button>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Header;